// "Nombre - CUIT" de un contrato u organismo, como lo muestran el detalle del siniestro y el
// drawer "Sobre el siniestro" (SMP-484). Devuelve '' si no hay ninguno de los dos.
export const formatNombreConCuit = (
    nombre?: string | null,
    cuit?: string | number | null
): string => [nombre, cuit ? String(cuit) : ''].filter(Boolean).join(' - ');
